import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CustomWidgetModel } from "app/models/customWidget.model";
import { Observable, Subject } from "rxjs";
import { switchMap, tap, map } from "rxjs/operators";
import { ApiService } from "./api.service";

@Injectable()
export class CustomWidgetService extends ApiService {
    private _onDeleteCustomWidget = new Subject<CustomWidgetModel>();
    private _onAddCustomWidget = new Subject<CustomWidgetModel>();
    private _onEditCustomWidget = new Subject<CustomWidgetModel>();
    private _widgetList: CustomWidgetModel[] = [];

    public readonly onDeleteCustomWidget: Observable<CustomWidgetModel> = this._onDeleteCustomWidget.asObservable();
    public readonly onAddCustomWidget: Observable<CustomWidgetModel> = this._onAddCustomWidget.asObservable();
    public readonly onEditCustomWidget: Observable<CustomWidgetModel> = this._onEditCustomWidget.asObservable();

    constructor(protected http: HttpClient) {
        super(http);
        this.apiEndpoint = "project";
    }

    public get widgetList(): CustomWidgetModel[] {
        return this._widgetList;
    }

    getAll(projectId: string): Observable<CustomWidgetModel[]> {
        return this.http.get<CustomWidgetModel[]>(this.getUrl(`${projectId}/custom-widget`)).pipe(tap((data) => (this._widgetList = data)));
    }

    create(projectId: string, customWidget: CustomWidgetModel): Observable<CustomWidgetModel> {
        return this.http.post<CustomWidgetModel>(this.getUrl(`${projectId}/custom-widget`), customWidget).pipe(
            switchMap((data) =>
                this.getAll(projectId).pipe(
                    tap(() => this._onAddCustomWidget.next(data)),
                    map(() => data),
                ),
            ),
        );
    }

    edit(projectId: string, customWidget: CustomWidgetModel): Observable<CustomWidgetModel> {
        return this.http.put<CustomWidgetModel>(this.getUrl(`${projectId}/custom-widget`), customWidget).pipe(
            switchMap((data) =>
                this.getAll(projectId).pipe(
                    tap(() => this._onEditCustomWidget.next(data)),
                    map(() => data),
                ),
            ),
        );
    }

    delete(projectId: string, customWidgetId: string) {
        return this.http.delete<CustomWidgetModel>(this.getUrl(`${projectId}/custom-widget/${customWidgetId}`)).pipe(
            switchMap((data) =>
                this.getAll(projectId).pipe(
                    tap(() => this._onDeleteCustomWidget.next(data)),
                    map(() => data),
                ),
            ),
        );
    }
}
